import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import dateFormat from "dateformat";
const SingleItem = ({ data, index, paginateData }) => {
  const [userData, setuserData] = useState([]);
  useEffect(() => {
    if (data?.user_id) {
      fetch(
        `https://api.wlffinance.org/api/admin/user/view/single/${data?.user_id}`,
        {
          method: "GET",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          setuserData(data.data);
        });
    }
  }, []);

 
  return (
    <>
      <tr>
        <td data-label="S.N.">
          {parseFloat(index + 1) +
            parseFloat(paginateData?.page) * parseFloat(paginateData?.limit) -
            10}
        </td>
        <td data-label="Full Name">
          <Link to={`/admin/users/details/${userData?._id}`}>
            <span className="d-block">
              {userData?.fname} {userData?.lname}
            </span>
            {userData?.uid}
          </Link>
        </td>
        <td data-label="Email">
          <Link to={`/admin/users/details/${userData?._id}`}>
          <span>{userData?.email}</span>
          </Link>
        </td>
        <td data-label="Crypto">
          <span>{data.Crypto}</span>
        </td>
        <td data-label="Amount">{data?.Amount} $</td>
        <td data-label="HighLow">
          {data.HighLow === "High" ? (
            <span className="badge badge--success text-success">High</span>
          ) : (
            <span className="badge badge--danger text-danger">Low</span>
          )}
        </td>
        <td data-label="Result">
          {data.Result === "Win" ? (
            <span className="badge badge--success text-success">Win</span>
          ) : (
            ""
          )}
          {data.Result === "Draw" ? (
            <span className="badge badge--dark text-dark">Draw</span>
          ) : (
            ""
          )}
          {data.Result === "Loss" ? (
            <span className="badge badge--danger text-danger">Loss</span>
          ) : (
            ""
          )}
        </td>
        <td data-label="Status">
          {data.Result === null ? (
            <span className="badge badge--danger text-danger">Running</span>
          ) : (
            <span className="badge badge--success text-success">Completed</span>
          )}
        </td>
        {/* <td data-label="Date"> {dateFormat(data.InTime)}</td> */}
        <td data-label="In Time"> {data.OutTime}</td>
      </tr>
    </>
  );
};

export default SingleItem;
